// scripts
import { uiTabs } from './modules/tabs';

function carCount() {
	let el = document.getElementById('car-amount');
	let count = document.getElementsByClassName('car-list-countable').length;
	el.textContent = count;
}

window.addEventListener('load', function () {
	uiTabs();
	carCount();
});
